export const defaultBorderedClass = 'bordered'

export const defaultInputclass = 'defaultInput';

export const backgroundColor = 'var(--backgroundColor)'
export const baseColor = 'var(--baseElementColor)'
export const scndColor = 'var(--2cndElementColor)'
export const contrastColor = 'var(--contrastElementColor)'

export const errorColor = 'var(--errorColor)'

export const paddingWidth = 'var(--bordered-width)'
export const paddingHeight = 'var(--bordered-height)'

export const backUrl = '/api/v1'

export function FormatDate(date) {
    const formattedDate = new Date(date).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit'
    });

    return formattedDate;
}

export function FormatExperience(experience) {
    const currentYear = new Date().getFullYear();
    const formattedExperience = currentYear - experience;
    return formattedExperience;
}

export function classNames(...args) {
    const classes = [];

    args.forEach((arg) => {
        if (!arg) return; // Пропускаем falsy значения (null, undefined, false, 0, '')

        // Если аргумент — строка или число, добавляем его в массив
        if (typeof arg === 'string' || typeof arg === 'number') {
            classes.push(arg);
        }

        // Если аргумент — объект, добавляем ключи, значения которых true
        else if (typeof arg === 'object') {
            if (Array.isArray(arg)) {
                // Если это массив, рекурсивно вызываем classNames для его элементов
                classes.push(classNames(...arg));
            } else {
                // Если это объект, добавляем ключи, значения которых true
                for (const key in arg) {
                    if (arg.hasOwnProperty(key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
    });

    // Объединяем все классы в одну строку
    return classes.join(' ');
}


function getTrueKeys(obj) {
    return Object.entries(obj)
        .filter(([_, value]) => value === true)
        .map(([key]) => key);
}


export function arrayToObject(arr) {
    if (!arr) return undefined;
    return arr.reduce((acc, key) => {
        acc[key] = true;
        return acc;
    }, {});
}

export function objectToArray(obj) {
    if (!obj) return undefined;
    return Object.entries(obj)
        .filter(([_, value]) => value)
        .map(([key]) => key);
}

export function convertDTOToUrlParams(dto) {
    const params = new URLSearchParams();
    Object.entries(dto).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else if (typeof value === 'boolean') {
            params.set(key, value ? 'true' : 'false');
        } else if (!!value) {
            params.set(key, String(value));
        }
    });

    return params

}

export function getIsoDateFromDateTime(isoDateTime) {
    // 1. Проверяем наличие 'T' в строке
    if (!isoDateTime.includes('T')) {
        // Если строка уже содержит только дату, возвращаем как есть
        return isoDateTime.split('T')[0];
    }

    // 2. Создаем объект Date из строки
    const date = new Date(isoDateTime);

    // 3. Проверяем валидность даты
    if (isNaN(date.getTime())) {
        throw new Error('Invalid ISO date-time format');
    }

    // 4. Форматируем в ISO-дату (YYYY-MM-DD)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const clampNumber = (num, a, b) => Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b))

export function convertToUnifiedLineBreak(line) {
    return line.replace(/\\r\\n/g, '\n')
            .replace(/\\n/g, '\n')
            .replace(/\\r/g, '\n')
}